import { useAppSelector } from '@/redux';
import { RolesKeys, designations } from '@/utils';

export const useUserRole = () => {
	const profile = useAppSelector(state => state.auth.userProfile);
	return profile?.user_role_id;
};

export function useUserRolesIn(roles: RolesKeys[]) {
	const profile = useAppSelector(state => state.auth.userProfile);
	const roleId = profile?.user_role_id;
	return roles.some(key => roleId === designations[key]);
}
